// @flow

import radio from 'app/developer-v3/components/PartnerSupportForm/components/blocks/Radio';

import { buildingFirstTime } from '../common/newOrExisitng/buildingFirstTime';
import { createPublishingYourApp } from '../common/newOrExisitng/publishingYourApp';
import { createNoAppPartnerProgram } from '../common/noAppYet/partnerProgram';

const noAppYetChild = radio({
  id: 'noappyet',
  label: 'Tell us more',
  items: [
    buildingFirstTime(false, 'new'),
    createPublishingYourApp(false, 'new'),
    createNoAppPartnerProgram(false),
  ],
});

export default noAppYetChild;
